<template>
  <v-dialog v-model="isOpen" persistent max-width="500">
    <v-card class="align-center text-center">
      <v-card-text>
        <div class="pt-5 d-flex align-center justify-space-between">
          <h1>Alterar Data de Previsão</h1>
          <v-btn icon @click="close()" class="align-self-end">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </div>

        <div class="mt30"></div>
        <v-form ref="aditionalForm">
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="isDatePickerOpen"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDate"
                    label="Data de previsão"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="forecastDate" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
        <div class="mt10"></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pb-5">
        <v-btn color="error" class="flex-grow-1" large @click="close()"> Cancelar </v-btn>
        <v-btn color="success" class="flex-grow-1" large :loading="isButtonLoading" @click="handleForecastUpdate">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    deliveryToUpdate: {
      default: null,
      type: Object
    }
  },

  data: () => ({
    isDatePickerOpen: false,
    forecastDate: null,
    isButtonLoading: false
  }),

  computed: {
    formattedDate() {
      if (!this.forecastDate) return '';
      const [year, month, day] = this.forecastDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  watch: {
    isOpen: {
      handler(isOpen) {
        if (isOpen) {
          this.forecastDate = this.formatDateOnOpen(this.deliveryToUpdate.deliveryForecast);
        }
      }
    }
  },

  methods: {
    ...mapActions('QuarantineStore', ['updateDeliveryForecastDate']),
    formatDateOnOpen(date) {
      const [day, month, year] = date.split('/');
      return `${year}-${month}-${day}`;
    },

    async handleForecastUpdate() {
      try {
        this.isButtonLoading = true;
        const { id: deliverieId } = this.deliveryToUpdate;
        const params = { deliverieId, deliveryForecast: this.forecastDate };
        const res = await this.updateDeliveryForecastDate(params);

        if (res.success) {
          this.$emit('feedbackMessage', {
            errors: ['Data de previsão atualizada com sucesso!'],
            errorsType: 'success'
          });
          this.close();
        } else {
          this.$emit('feedbackMessage', {
            errors: res.errors,
            errorsType: 'error'
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isButtonLoading = false;
      }
    },

    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style></style>
